import useAccountQuery from 'api/queries/useAccountQuery';
import useEBTChargeAmountQuery from 'api/queries/useEBTChargeAmountQuery';
import useSelectionsQuery from 'api/queries/useSelectionsQuery';
import { useAccountPlusMembershipHook } from 'hooks/useAccountPlusMembershipHook/useAccountPlusMembershipHook';
import { getOrderMin } from 'utils/orderUtils';
import { getOrderMinMet, PriceType } from 'utils/priceUtils';

/**
 * Hook that returns the order minimum and whether it's met, accounting for EBT charges.
 * If an EBT charge exists for the current order, returns 0 as the minimum (no minimum required).
 * Otherwise returns the normal order minimum from account data.
 * Also calculates if the current grocery subtotal meets or exceeds the order minimum.
 *
 * @returns {{ orderMin: number, isOrderMinMet: boolean }} Object containing the order minimum value and whether it's met
 */
export default function useOrderMin() {
    const { data: account } = useAccountQuery();
    const { data: ebtChargeAmount } = useEBTChargeAmountQuery();
    const { data: selections } = useSelectionsQuery();
    const { plusMembershipEligibleOrder } = useAccountPlusMembershipHook();

    const currentEBTChargeAmount = ebtChargeAmount?.ebtAmount ?? 0;

    const orderMin = currentEBTChargeAmount > 0 ? 0 : getOrderMin(account);

    const priceType = plusMembershipEligibleOrder ? PriceType.PLUS_MEMBER : PriceType.DEFAULT;
    const isOrderMinMet = selections
        ? getOrderMinMet({
              options: { orderMin, priceType },
              selections,
          })
        : false;

    return { isOrderMinMet, orderMin };
}
